import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Offices (/offices). Anchors live in OfficesWorkspacePage.tsx. */
export function getOfficesTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Your offices',
        description:
          'Your brokerage offices come in from your MLS automatically. Each office gets its own ' +
          'page on your website showing its address and phone, its agents, their listings and ' +
          'their recent sales.',
      },
    },
    {
      element: at('offices-add'),
      popover: {
        title: 'Add an office yourself',
        description:
          'Missing an office from your MLS? Click “Add Manual Office” to add it by hand with its ' +
          'name, phone and address.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('offices-stats'),
      popover: {
        title: 'At a glance',
        description:
          'How many offices came from your MLS, how many you added yourself, and how many you’ve ' +
          'marked as featured.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('offices-list'),
      popover: {
        title: 'Your office list',
        description:
          'Each card shows an office’s location, phone, address and description. A badge tells you ' +
          'whether it came from your MLS or was added by hand.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: at('offices-edit'),
      popover: {
        title: 'Edit an office',
        description:
          'Click “Edit Office Content” to update the office’s name, phone, address, photo and ' +
          'description, or mark it as a featured office. Publish your site afterwards so visitors ' +
          'see the changes.',
        side: 'top',
        align: 'center',
      },
    },
  ];
}
